import React, { lazy } from 'react';
import Loadable from 'src/components/Loadable';

const HomePageView = Loadable(
  lazy(() => import('src/pages/home/HomePageView'))
);
const ProServLibraryListPageView = Loadable(
  lazy(() => import('src/pages/home/ProServLibraryListPage'))
);
const ProServLibraryDetailPageView = Loadable(
  lazy(() => import('src/pages/home/ProServLibraryDetailPage'))
);

const routes = [
  {
    path: 'home',
    element: <HomePageView />
  },
  {
    id: 'ps-library',
    path: 'ps-library',
    element: <ProServLibraryListPageView />,
    handle: {
      isEAP: true
    }
  },
  {
    id: 'ps-library-detail',
    path: 'ps-library/:id',
    element: <ProServLibraryDetailPageView />,
    handle: {
      isEAP: true
    }
  }
];

export default routes;
